import * as React from 'react';
import Box from '@mui/material/Box';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepButton from '@mui/material/StepButton';
import Typography from '@mui/material/Typography';
import { makeStyles } from '@mui/styles';
import { StepContent, StepLabel, Theme, useMediaQuery } from '@mui/material';

const steps = ['Die Basis', 'Inner Circle', 'Klarheit', 'Herausforderungen', 'Wolfühlfaktor', 'Glücklich & Zufrieden'];
const stepDescriptions = [
        <dl>
            <dt><Typography variant="h5" component="p">Die Basis</Typography></dt>
            <dd>
                Wir besprechen die Rahmenbedingungen Eurer Hochzeit, kümmern uns um Deine Prioritäten und No Go’s und schauen wie Du sie am Besten umsetzen und beibehalten kannst. Wir strukturieren die Planungsschritte für Eure Hochzeit so, dass keine Überlastung entsteht.
            </dd>
        </dl>
    ,
    <dl>
        <dt><Typography variant="h5" component="p">Inner Circle</Typography></dt>
        <dd>
        Wir alle benötigen die Unterstützung unserer Liebsten bei so großen und emotionalen Ereignissen wie einer Hochzeit. Sicher fallen Dir genau <strong>jetzt</strong> schon Personen ein, die Dir mit Rat und Tat zur Seite stehen.  Wir gehen in die Tiefe und schauen auch wer dir wo die größtmögliche Unterstützung bieten kann. Außerdem wird emotionale Kommunikation eine große Rolle spielen.
        </dd>
    </dl>,
    <dl>
        <dt><Typography variant="h5" component="p">Klarheit</Typography></dt>
        <dd>
        Wie oft hast Du über das Dekokonzept schon nachgedacht? Hast du immer an das Gleiche gedacht oder überlegst du hin und her? Wir schaffen in dieser Phase klare Gedanken. Außerdem geht es um Stress. Wie empfindest du Stress, wann und warum. Das sind wichtige Grundsteine, um eben diesen Situationen vorzubeugen und langfristige emotionale Belastung dadurch zu vermeiden.
        </dd>
    </dl>,
    <dl>
        <dt><Typography variant="h5" component="p">Herausforderungen</Typography></dt>
        <dd>
        Wir streichen das Wort „Problem“ aus deinem Hochzeitswortschatz. In unserem vierten Coaching Termin ist Platz für deine Herausforderungen, welche Dir während den Hochzeitsvorbereitungen immer wieder begegnen und welche du nicht überwinden kannst. Wir greifen dabei auf deine Prioritäten zurück und analysieren Deinen IST-Zustand.
        </dd>
    </dl>,
    <dl>
        <dt><Typography variant="h5" component="p">Wolfühlfaktor</Typography></dt>
        <dd>
        Denkst du bei diesem Wort auch an ein heißes Bad oder einen flackernden Kamin? Was löst den Wohlfühlfaktor in Dir aus und wie bekommen wir ihn auf Eure Hochzeit. Das wird unser Thema des Tages.
        </dd>
    </dl>,
    <dl>
        <dt><Typography variant="h5" component="p">Glücklich & Zufrieden</Typography></dt>
        <dd>
        Wir sind am Ziel! Wir lassen die Zeit Revue passieren und starten ein kleines Gedanken-Experiment.
        </dd>
    </dl>

]

const useStyles = makeStyles((theme: any) => ({
  stepIconActive: {
    color: '#9E4BD6 !important',
  },
}));   


export default function CoachingStepper() {
  const [activeStep, setActiveStep] = React.useState(0);
  const classes = useStyles();
  const smOrLower = useMediaQuery<Theme>((theme) => theme.breakpoints.down('sm'));

  const handleStep = (step: number) => () => {
    setActiveStep(step);
  };


  return (
    <Box textAlign="center" display={'flex'} alignContent={"center"}  flexDirection={"column"} marginTop={"30px"} className="descriptionList">
      {!smOrLower && 
        <div style={{maxWidth: '1400px'}}>
          <React.Fragment>
          {stepDescriptions[activeStep]}
          </React.Fragment>
      </div>
      } 
      <Stepper nonLinear orientation={smOrLower?"vertical":"horizontal"} activeStep={activeStep}>
        {steps.map((label, index) => (
          <Step key={label}>
            {!smOrLower && 
               <StepButton disableRipple color="inherit" onClick={handleStep(index)}>
                <StepLabel 
                  StepIconProps={{ 
                    classes: { active: classes.stepIconActive} 
                  }}
                >
                  {label} 
                </StepLabel>
               </StepButton>
            }
            {smOrLower && 
              <React.Fragment>
                <StepLabel 
                  StepIconProps={{ 
                    classes: { active: classes.stepIconActive} 
                  }}
                  onClick={handleStep(index)}
                >
                  {label} 
                </StepLabel>
                <StepContent>
                  {stepDescriptions[activeStep]}
                </StepContent>
              </React.Fragment>
            }
           
          </Step>
        ))}
      </Stepper>
    </Box>
  );
}